import { Outlet, useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';
import { ScrollToTop } from './ScrollToTop';
import { WhatsAppFloat } from './WhatsAppFloat';

export function SiteLayout() {
  const { pathname } = useLocation();
  return (
    <div className="site-shell">
      <ScrollToTop />
      <Header />
      <main key={pathname} className="route-content"><Outlet /></main>
      <Footer compact={pathname === '/contacto'} />
      <WhatsAppFloat />
    </div>
  );
}
